import { useContextState } from '../../../../../../../../hooks/theme'

const useStyles = () => {
  const { colors } = useContextState()

  return {
    daysOfWeek: (flag:boolean) => ({
        width: 50,
        height: 50,
        borderRadius: '50%',
        backgroundColor: flag ? colors.color8 : colors.color39,
        color: flag ? 'white' : colors.color13,
        transition: 'background-color 0.3s',
        '&:hover': {
            backgroundColor: flag ? colors.color8 : colors.color32,
        },
    })
  }
}

export { useStyles }